import userFiltersSignal, {
	setUserFilters,
} from '@UI/Pages/Administration/Users/Filters/Signals/userFiltersSignal';
import type { ComposedOrganization } from '@UI/Providers/CurrentOrganizationProvider/helpers/composeAssignedOrganizations';
import * as React from 'react';
import { useSignalValue } from '@verclam/pulsar';
import { Dropdown } from '@verclam/ui-kit';

type Props = {
	/** `null` while still loading. */
	readonly organizations: readonly ComposedOrganization[] | null;
	readonly withLabel?: boolean;
};

const OrganizationFilter: React.FC<Props> = ({ organizations, withLabel = false }) => {
	const currentFilters = useSignalValue(userFiltersSignal);

	const handleOrganizationChange = React.useCallback((organizationId: number | null) => {
		setUserFilters(userFiltersSignal.peek().setOrganizationId(organizationId));
	}, []);

	return (
		<Dropdown<number>
			name="userOrganization"
			label="Structure"
			isLabelHidden={!withLabel}
			placeholder="Toutes les structures"
			options={organizations ?? []}
			optionLabel="name"
			optionValue="id"
			loading={organizations === null}
			showClear
			value={currentFilters.organizationId}
			onChange={handleOrganizationChange}
		/>
	);
};

export default OrganizationFilter;
